// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppHeader__header___CnLVx {
    position: sticky;
    top: 0;

    flex-shrink: 0;

    height: 4.8rem;

    border-bottom: var(--control-border-width) solid var(--color-bg-border);
}

.AppHeader__exitButton___hWY__ {
    padding: 0;
}

.AppHeader__exitButton___hWY__ span {
    flex-grow: initial;
    margin: 0;
    text-align: left;
}

.AppHeader__userPopover___ijJ_8 {
    display: flex;
    flex-direction: column;

    width: 24.8rem;
    padding: 0.8rem 0;

    background-color: var(--color-bg-default);
    border: 0.1rem solid var(--color-bg-border);
    border-radius: 0.4rem;
    box-shadow:
        0 0.2rem 0.2rem rgba(0 32 51 / 4%),
        0 0.4rem 1.6rem rgba(0 32 51 / 18%);
}

.AppHeader__popoverItem___euZAa {
    display: flex;
    flex-direction: row;
    gap: 1.2rem;
    align-items: center;
    justify-content: flex-start;

    padding: 0.8rem 1.2rem;

    font-family: Inter, serif;
}

.AppHeader__version___WSNe3 {
    justify-content: flex-end;
}

.AppHeader__delimiter____LtGD {
    --delimiter-size: 90%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/AppHeader.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,MAAM;;IAEN,cAAc;;IAEd,cAAc;;IAEd,uEAAuE;AAC3E;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;;IAEtB,cAAc;IACd,iBAAiB;;IAEjB,yCAAyC;IACzC,2CAA2C;IAC3C,qBAAqB;IACrB;;2CAEuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,2BAA2B;;IAE3B,sBAAsB;;IAEtB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".header {\n    position: sticky;\n    top: 0;\n\n    flex-shrink: 0;\n\n    height: 4.8rem;\n\n    border-bottom: var(--control-border-width) solid var(--color-bg-border);\n}\n\n.exitButton {\n    padding: 0;\n}\n\n.exitButton span {\n    flex-grow: initial;\n    margin: 0;\n    text-align: left;\n}\n\n.userPopover {\n    display: flex;\n    flex-direction: column;\n\n    width: 24.8rem;\n    padding: 0.8rem 0;\n\n    background-color: var(--color-bg-default);\n    border: 0.1rem solid var(--color-bg-border);\n    border-radius: 0.4rem;\n    box-shadow:\n        0 0.2rem 0.2rem rgba(0 32 51 / 4%),\n        0 0.4rem 1.6rem rgba(0 32 51 / 18%);\n}\n\n.popoverItem {\n    display: flex;\n    flex-direction: row;\n    gap: 1.2rem;\n    align-items: center;\n    justify-content: flex-start;\n\n    padding: 0.8rem 1.2rem;\n\n    font-family: Inter, serif;\n}\n\n.version {\n    justify-content: flex-end;\n}\n\n.delimiter {\n    --delimiter-size: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `AppHeader__header___CnLVx`,
	"exitButton": `AppHeader__exitButton___hWY__`,
	"userPopover": `AppHeader__userPopover___ijJ_8`,
	"popoverItem": `AppHeader__popoverItem___euZAa`,
	"version": `AppHeader__version___WSNe3`,
	"delimiter": `AppHeader__delimiter____LtGD`
};
export default ___CSS_LOADER_EXPORT___;
